import {
	Dialog,
	DialogTrigger,
	DialogSurface,
	DialogTitle,
	DialogBody,
	DialogContent,
	Button,
	Text,
	tokens,
	mergeClasses,
} from "@fluentui/react-components";
import { DialogProps, DialogSize } from "./types";
import { Dismiss16Regular } from "@fluentui/react-icons";
import { useStyle } from "./styles";
import MessageOutlet from "@/common/messages/outlet";

export const DialogView = (props: DialogProps) => {
	const classes = useStyle();
	const {
		title,
		content,
		open,
		setOpen,
		trigger,
		size = DialogSize.Medium,
		onKeyDown,
	} = props;

	const sizeClassMap = {
		[DialogSize.Small]: classes.dialogSmall,
		[DialogSize.Medium]: undefined,
		[DialogSize.Large]: classes.dialogLarge,
	};

	return (
		<Dialog open={open} onOpenChange={(_, data) => setOpen(data.open)}>
			<DialogTrigger disableButtonEnhancement>{trigger}</DialogTrigger>
			<DialogSurface
				className={mergeClasses(classes.dialog, sizeClassMap[size])}
				backdrop={<MessageOutlet namespace="dialog" />}
				onKeyDown={onKeyDown}
			>
				<DialogBody>
					<DialogTitle
						action={
							<Button
								appearance="subtle"
								aria-label="close"
								icon={<Dismiss16Regular />}
								onClick={() => {
									setOpen(false);
								}}
							/>
						}
					>
						{title && (
							<Text
								weight="bold"
								style={{ color: tokens.colorNeutralForeground3 }}
							>
								{title}
							</Text>
						)}
					</DialogTitle>
					<DialogContent>{content}</DialogContent>
				</DialogBody>
			</DialogSurface>
		</Dialog>
	);
};
